module.exports = __webpack_public_path__ + "img/vashe_pravo.87069692.jpg";